import type { HTMLAttributes } from 'react'

export interface LockIconProps extends HTMLAttributes<SVGSVGElement> {}

export default function LockIcon({ ...props }: LockIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			{...props}
		>
			<rect
				x="2.44995"
				y="5"
				width="7.1"
				height="5.5"
				rx="1"
				stroke="currentColor"
				strokeWidth="1.2"
			/>
			<path
				d="M8.5 5V3.5C8.5 2.39543 7.60457 1.5 6.5 1.5H5.5C4.39543 1.5 3.5 2.39543 3.5 3.5V5"
				stroke="currentColor"
				strokeWidth="1.2"
			/>
			<path d="M6 7.5V8.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
		</svg>
	)
}
